import { useEffect, useState } from "react";

const SCRIPT_ID = "razorpay-checkout";
const SCRIPT_SRC = "https://checkout.razorpay.com/v1/checkout.js";

export function useRazorpayScript() {
  const [ready, setReady] = useState(!!window.Razorpay);

  useEffect(() => {
    if (window.Razorpay) { setReady(true); return; }
    let script = document.getElementById(SCRIPT_ID);
    if (!script) {
      script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.src = SCRIPT_SRC;
      script.async = true;
      document.body.appendChild(script);
    }
    const onLoad = () => setReady(true);
    script.addEventListener("load", onLoad);
    if (script.dataset.loaded === "true") setReady(true);
    return () => script.removeEventListener("load", onLoad);
  }, []);

  return ready;
}
